import { AriaDatapoint } from '../datapoints/AriaDatapoint';
import { isFeatureEnabled } from 'owa-feature-flags';
import { trace } from 'owa-trace';
import { testForPii } from 'owa-config';

export function safeStringify(input: any): string {
    try {
        return JSON.stringify(input);
    } catch (e) {
        return e.message;
    }
}

export function validateString(value: string) {
    return testForPii(value) || value;
}

export function validatePropertyBag(datapoint: AriaDatapoint): string {
    if (isFeatureEnabled('fwk-turnOffCustomData')) {
        return 'emergency flight on';
    }

    if (datapoint.propertyBag) {
        var keys = Object.keys(datapoint.propertyBag);
        for (var ii = 0; ii < keys.length; ii++) {
            var propertyKey = keys[ii];
            var propertyValue = datapoint.propertyBag[propertyKey];
            var errorMessage = null;
            if (
                propertyKey.toLowerCase().indexOf('subject') > -1 &&
                typeof propertyValue == 'string'
            ) {
                errorMessage = "'s key contains subject";
            } else if (propertyValue) {
                errorMessage =
                    typeof propertyValue == 'object' && !(propertyValue instanceof Date)
                        ? ' is an object'
                        : testForPii(propertyValue.toString());
            }

            if (errorMessage) {
                trace.error(
                    propertyKey +
                        ' of datapoint ' +
                        datapoint.eventName +
                        errorMessage +
                        ' which is pii'
                );
                return errorMessage;
            }
        }
    }

    return safeStringify(datapoint.propertyBag);
}
